import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getAll(accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/materialclasses?accountID=${accountID}`
      }))
  );
}

async function getById(materialClassID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/materialclasses/${materialClassID}`
      }))
  );
}

async function create(materialClass) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        body: JSON.stringify(materialClass),
        url: '/materialclasses'
      }))
  );
}

async function update(materialClass) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        body: JSON.stringify(materialClass),
        url: `/materialclasses/${materialClass.materialClassID}`
      }))
  );
}

// prefixed function name with underscore because delete is a reserved word in javascript
async function Delete(materialClassID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/materialclasses/${materialClassID}`
      }))
  );
}

const materialClassService = {
  getAll,
  getById,
  create,
  update,
  delete: Delete
};

export default materialClassService;
